import type { CookieSetOptions } from 'universal-cookie';
import Cookies from 'universal-cookie';

import datetime, { TimeUnit } from '@/infra/adapters/datetime';

export enum CookieKey {
    SYS_TYPE = 'sys_type',
    THEME = 'theme',
    ACCT = 'account',
    CRDL = 'credential',
    BV_CLMN = 'bv_column',
    BV_HIST_CLMN = 'bv_history_column',
}

const cookies = new Cookies();
export const getCookie = (key: CookieKey): any => {
    let name = key as string;
    if (key !== CookieKey.SYS_TYPE && key !== CookieKey.THEME) {
        const systemType = cookies.get(CookieKey.SYS_TYPE);
        name += '.' + systemType;
    }
    return cookies.get(name);
};

export const setCookie = (key: CookieKey, value?: any): void => {
    let name = key as string;
    if (key !== CookieKey.SYS_TYPE && key !== CookieKey.THEME) {
        const systemType = cookies.get(CookieKey.SYS_TYPE);
        name += '.' + systemType;
    }

    const opt: CookieSetOptions = {
        path: '/',
        secure: true,
        sameSite: 'strict',
    };
    if (!value) {
        cookies.remove(name, opt);
    } else {
        if (key == CookieKey.CRDL) {
            opt.expires = datetime.getExpiredTime(3);
        } else {
            opt.expires = datetime.getExpiredTime(3, TimeUnit.YR);
        }
        cookies.set(name, value, opt);
    }
};
